import { PROJECT_PAGE_SIZE, type ProjectListArg } from '@/model/project/api';
import type { ProjectResponse } from '@/model/project/dto.generated';
import { logger } from '@/shared/helpers/logger';

const PROJECT_KIND_STANDARD = 'standard';

export const PROJECT_PAGE_SIZE_MAX = 100;

export const projectListArg = (
  workspaceId: string,
  search: string,
  limit: number = PROJECT_PAGE_SIZE,
): ProjectListArg => {
  const q = search.trim();
  return { workspaceId, limit, ...(q ? { q } : {}) };
};

export function toProjectResponse(p: Partial<ProjectResponse>): ProjectResponse {
  if (!p.id || !p.workspace_id) {
    logger.warn('toProjectResponse: missing critical fields', {
      log_source: 'projectData.types',
      id: p.id,
      workspace_id: p.workspace_id,
    });
  }
  return {
    id: p.id ?? '',
    workspace_id: p.workspace_id ?? '',
    name: p.name ?? '',
    slug: p.slug ?? '',
    region: p.region ?? '',
    status: p.status ?? '',
    created_at: p.created_at ?? '',
    updated_at: p.updated_at ?? '',
    request_id: p.request_id ?? '',
    description: p.description ?? '',
    kind: p.kind ?? PROJECT_KIND_STANDARD,
  };
}

export function isSystemProject(project: Partial<Pick<ProjectResponse, 'kind'>>): boolean {
  return (project.kind ?? PROJECT_KIND_STANDARD) !== PROJECT_KIND_STANDARD;
}
